import styled from 'styled-components';

const MainTitle = styled.h2`
  color: #e9226f;
  font-weight: 600;
  font-size: 16px;
  margin: 5px 0 0 0;
`;

const SecondaryTitle = styled.h3`
  color: #c1b9cb;
  font-weight: 400;
  font-size: 16px;
  span {
    color: #d9d2de;
    font-weight: 600;
  }
  margin: 5px 0 0 0;
`;

export { MainTitle, SecondaryTitle };
